/* eslint-disable */
/**
 * GENERATED by scripts/generate-blog-tag-catalog.mjs — do not edit by hand.
 * Bilingual summaries of every tagged blog post (static catalogs + Supabase).
 */
export const BLOG_TAG_POSTS = [
  {
    "slug": "custom-software-development-company-guide",
    "source": "static",
    "publishedAt": "2026-07-05",
    "title": {
      "tr": "Özel Yazılım Geliştirme Şirketi Nasıl Seçilir? (2026 Rehberi)",
      "en": "How to Choose a Custom Software Development Company (2026 Guide)"
    },
    "excerpt": {
      "tr": "Özel yazılım geliştirme şirketi ararken teknik, süreç ve maliyet kriterlerini nasıl değerlendirmelisiniz?",
      "en": "How to evaluate technical, process, and cost criteria when hiring a custom software development company."
    },
    "category": {
      "tr": "Yazılım",
      "en": "Software"
    },
    "readingMinutes": {
      "tr": 1,
      "en": 1
    },
    "headings": {
      "tr": [
        "Teknik derinlik mi, proje yönetimi mi?",
        "Teslimat modeli: sprint değil, risk azaltma",
        "Maliyet: sabit fiyat tuzağı"
      ],
      "en": [
        "Technical depth or project management?",
        "Delivery model: risk reduction, not just sprints",
        "Cost: the fixed-price trap"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "özel yazılım geliştirme",
      "yazılım şirketi",
      "custom software development company",
      "software development partner"
    ],
    "tags": [
      "ozel-yazilim-gelistirme",
      "yazilim-sirketi",
      "custom-software-development-company",
      "software-development-partner"
    ]
  },
  {
    "slug": "ai-development-company-selection-guide",
    "source": "static",
    "publishedAt": "2026-07-03",
    "title": {
      "tr": "Yapay Zeka Yazılım Şirketi Seçerken 7 Kritik Soru",
      "en": "7 Critical Questions When Choosing an AI Development Company"
    },
    "excerpt": {
      "tr": "AI development company arayan ekipler için PoC tuzağından production’a geçiş checklist’i.",
      "en": "A production-readiness checklist for teams evaluating an AI development company beyond the PoC trap."
    },
    "category": {
      "tr": "AI",
      "en": "AI"
    },
    "readingMinutes": {
      "tr": 2,
      "en": 3
    },
    "headings": {
      "tr": [
        "1. Demo mu teslim ediyorsunuz, production mı?",
        "2. Canlıya almadan önce hangi guardrail’leri kuruyorsunuz?",
        "3. RAG ve yanıt kalitesini nasıl ölçüyorsunuz?",
        "4. Verimiz nereye gidiyor, kim erişebiliyor?",
        "5. Token ve API maliyetini nasıl kontrol altında tutuyorsunuz?",
        "6. Başarıyı hangi ürün metrikleriyle ölçeceğiz?"
      ],
      "en": [
        "1. Do you deliver demos or production systems?",
        "2. Which guardrails do you put in place before launch?",
        "3. How do you measure RAG and answer quality?",
        "4. Where does our data go, and who can access it?",
        "5. How do you keep token and API cost under control?",
        "6. Which product metrics will define success?"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "yapay zeka yazılım şirketi",
      "AI development company",
      "AI product development",
      "LLM integration"
    ],
    "tags": [
      "ai-development-company",
      "ai-product-development",
      "llm-integration"
    ]
  },
  {
    "slug": "saas-development-cost-guide",
    "source": "static",
    "publishedAt": "2026-07-01",
    "title": {
      "tr": "SaaS Geliştirme Maliyeti: 2026 Gerçekçi Aralıklar ve Kapsam",
      "en": "SaaS Development Cost: Realistic 2026 Ranges and Scope"
    },
    "excerpt": {
      "tr": "SaaS geliştirme maliyeti neden teklifler arasında 3x fark eder? Kapsam, ekip ve mimari faktörleri.",
      "en": "Why SaaS development quotes differ 3x? Scope, team shape, and architecture factors explained."
    },
    "category": {
      "tr": "SaaS",
      "en": "SaaS"
    },
    "readingMinutes": {
      "tr": 2,
      "en": 2
    },
    "headings": {
      "tr": [
        "Örnek kapsam senaryoları (koşullu, KDV hariç)",
        "Örnek TRY bantları (abonelikli B2B SaaS profili)",
        "MVP vs v1 vs scale",
        "Maliyeti şişiren gizli kalemler",
        "Figures ile nasıl bütçe netleşir?"
      ],
      "en": [
        "Sample scope scenarios (conditional, excl. VAT)",
        "Illustrative TRY bands (subscription B2B SaaS profile)",
        "MVP vs v1 vs scale",
        "Hidden cost drivers",
        "How we clarify budget at Figtures"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "SaaS geliştirme",
      "SaaS development cost",
      "SaaS MVP",
      "SaaS development company"
    ],
    "tags": [
      "saas-gelistirme",
      "saas-development-cost",
      "saas-mvp",
      "saas-development-company"
    ]
  },
  {
    "slug": "mobile-app-development-cost-guide",
    "source": "static",
    "publishedAt": "2026-06-28",
    "title": {
      "tr": "Mobil Uygulama Geliştirme Maliyeti: iOS, Android ve Cross-Platform",
      "en": "Mobile App Development Cost: iOS, Android, and Cross-Platform"
    },
    "excerpt": {
      "tr": "Mobil uygulama geliştirme fiyatları neleri kapsar? Native vs cross-platform karşılaştırması.",
      "en": "What mobile app development pricing includes — native vs cross-platform compared."
    },
    "category": {
      "tr": "Mobil",
      "en": "Mobile"
    },
    "readingMinutes": {
      "tr": 1,
      "en": 1
    },
    "headings": {
      "tr": [
        "Native vs cross-platform",
        "Örnek TRY bantları (mobil ürün profili)",
        "Store dışı maliyetler",
        "AI özellikli mobil uygulama"
      ],
      "en": [
        "Native vs cross-platform",
        "Illustrative TRY bands (mobile product profile)",
        "Beyond the app store",
        "AI-enabled mobile apps"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "mobil uygulama geliştirme",
      "mobile app development cost",
      "mobile app development company",
      "iOS Android geliştirme"
    ],
    "tags": [
      "mobil-uygulama-gelistirme",
      "mobile-app-development-cost",
      "mobile-app-development-company",
      "ios-android-gelistirme"
    ]
  },
  {
    "slug": "chatgpt-integration-business-guide",
    "source": "static",
    "publishedAt": "2026-06-25",
    "title": {
      "tr": "İşletmeler İçin ChatGPT Entegrasyonu: Ürün İçi AI Asistan Rehberi",
      "en": "ChatGPT Integration for Business Products: In-App AI Assistant Guide"
    },
    "excerpt": {
      "tr": "ChatGPT entegrasyonu chatbot değildir — ürününüze güvenli AI asistan ekleme adımları.",
      "en": "ChatGPT integration is not a chatbot widget — steps to add a safe in-product AI assistant."
    },
    "category": {
      "tr": "AI Entegrasyon",
      "en": "AI Integration"
    },
    "readingMinutes": {
      "tr": 1,
      "en": 1
    },
    "headings": {
      "tr": [
        "Use-case netliği",
        "Güvenlik ve veri sınırları",
        "Production checklist"
      ],
      "en": [
        "Use-case clarity",
        "Security and data boundaries",
        "Production checklist"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "ChatGPT entegrasyonu",
      "ChatGPT integration",
      "AI assistant",
      "OpenAI integration services"
    ],
    "tags": [
      "chatgpt-integration",
      "ai-assistant",
      "openai-integration-services"
    ]
  },
  {
    "slug": "mvp-development-company-guide",
    "source": "static",
    "publishedAt": "2026-06-20",
    "title": {
      "tr": "MVP Geliştirme Şirketi Seçimi: Startup İçin 2026 Playbook",
      "en": "Choosing an MVP Development Company: 2026 Startup Playbook"
    },
    "excerpt": {
      "tr": "MVP geliştirme şirketi arayan founder’lar için scope, hız ve teknik borç dengesi.",
      "en": "Scope, speed, and technical debt balance for founders hiring an MVP development company."
    },
    "category": {
      "tr": "Startup",
      "en": "Startup"
    },
    "readingMinutes": {
      "tr": 1,
      "en": 1
    },
    "headings": {
      "tr": [
        "Scope: feature list değil hipotez listesi",
        "Teknik borç bilinçli alınır",
        "Yatırımcıya anlatılabilir teslimat"
      ],
      "en": [
        "Scope: hypothesis list, not feature list",
        "Technical debt is taken intentionally",
        "Investor-narratable delivery"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "MVP geliştirme",
      "MVP development company",
      "startup product engineering",
      "MVP maliyeti"
    ],
    "tags": [
      "mvp-gelistirme",
      "mvp-development-company",
      "startup-product-engineering",
      "mvp-maliyeti"
    ]
  },
  {
    "slug": "ux-design-in-ai-products",
    "source": "static",
    "publishedAt": "2026-03-28",
    "title": {
      "tr": "AI Ürünlerinde UX Tasarımının Önemi",
      "en": "The Importance of UX Design in AI Products"
    },
    "excerpt": {
      "tr": "Yapay zeka ürünlerinde kullanıcı deneyimini nasıl mükemmelleştiriyoruz? Pratik yaklaşımlar ve örnekler.",
      "en": "How we perfect user experience in AI products. Practical approaches and examples."
    },
    "category": {
      "tr": "Tasarım",
      "en": "Design"
    },
    "readingMinutes": {
      "tr": 1,
      "en": 1
    },
    "headings": {
      "tr": [
        "Açıklanabilirlik olmadan güven oluşmaz",
        "Hata durumlarını tasarlayın",
        "Ölçüm: doğruluk kadar kullanım da önemli"
      ],
      "en": [
        "No trust without explainability",
        "Design for failure states",
        "Measurement: usage matters as much as accuracy"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "AI",
      "AI product development",
      "UX design"
    ],
    "tags": [
      "ai",
      "ai-product-development",
      "ux"
    ]
  },
  {
    "slug": "saas-scaling-strategies",
    "source": "static",
    "publishedAt": "2026-03-22",
    "title": {
      "tr": "SaaS Ölçeklendirme Stratejileri",
      "en": "SaaS Scaling Strategies"
    },
    "excerpt": {
      "tr": "Ürününüz büyürken teknik altyapınızı nasıl ölçeklendirmelisiniz? Deneyimlerimizden dersler.",
      "en": "How should you scale your technical infrastructure as your product grows? Lessons from our experience."
    },
    "category": {
      "tr": "Mühendislik",
      "en": "Engineering"
    },
    "readingMinutes": {
      "tr": 1,
      "en": 1
    },
    "headings": {
      "tr": [
        "Önce ölç, sonra böl",
        "Veri katmanını erken güçlendirin",
        "Operasyonel otomasyon şart"
      ],
      "en": [
        "Measure first, split second",
        "Strengthen the data layer early",
        "Operational automation is mandatory"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "SaaS",
      "SaaS geliştirme"
    ],
    "tags": [
      "saas",
      "saas-gelistirme"
    ]
  },
  {
    "slug": "api-contract-evolution-without-breakage",
    "source": "cms",
    "publishedAt": "2026-03-12",
    "title": {
      "tr": "Kırmadan Evrim: Uzun Ömürlü API’lerde Sözleşme Yönetimi",
      "en": "Evolving Without Breaking: Contract Strategy for Long-Lived APIs"
    },
    "excerpt": {
      "tr": "Sürüm numarası değiştirmek tek başına çözüm değil. API evrimini güvenli yapan şey sözleşme ömrünü ölçülebilir ve geri alınabilir yönetmektir.",
      "en": "Version bumps alone rarely solve compatibility risk; durable API evolution requires measurable and reversible contract lifecycle management."
    },
    "category": {
      "tr": "Backend",
      "en": "Backend"
    },
    "readingMinutes": {
      "tr": 2,
      "en": 2
    },
    "headings": {
      "tr": [],
      "en": []
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "backend",
      "api-design",
      "compatibility",
      "deprecation",
      "schema-evolution"
    ],
    "tags": [
      "backend",
      "api-design",
      "compatibility",
      "deprecation",
      "schema-evolution"
    ]
  },
  {
    "slug": "mvp-development-guide",
    "source": "static",
    "publishedAt": "2026-03-08",
    "title": {
      "tr": "Startup'lar İçin MVP Geliştirme Rehberi",
      "en": "MVP Development Guide for Startups"
    },
    "excerpt": {
      "tr": "Minimum uygulanabilir ürün geliştirirken dikkat edilmesi gereken kritik noktalar.",
      "en": "Critical points to consider when developing a minimum viable product."
    },
    "category": {
      "tr": "Strateji",
      "en": "Strategy"
    },
    "readingMinutes": {
      "tr": 1,
      "en": 1
    },
    "headings": {
      "tr": [
        "Önce risk haritası çıkarın",
        "Ölçülebilir başarı tanımı koyun",
        "Teknik borcu kontrollü alın"
      ],
      "en": [
        "Map risks before features",
        "Define measurable success",
        "Take technical debt intentionally"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "MVP",
      "MVP geliştirme"
    ],
    "tags": [
      "mvp",
      "mvp-gelistirme"
    ]
  },
  {
    "slug": "evaluation-debt-in-ai-product-features",
    "source": "cms",
    "publishedAt": "2026-02-01",
    "title": {
      "tr": "Değerlendirme Borcu: AI Özellikleri Neden Sessizce Bozulur?",
      "en": "Evaluation Debt: Why AI Features Quietly Degrade"
    },
    "excerpt": {
      "tr": "AI kalitesini model sürümüyle değil değerlendirme sistemiyle taşırsınız. Sessiz kalite düşüşünü nasıl görünür kıldığımızı anlatıyorum.",
      "en": "Sustainable AI quality depends less on model swaps and more on evaluation architecture that detects silent drift early."
    },
    "category": {
      "tr": "Yapay Zeka",
      "en": "AI"
    },
    "readingMinutes": {
      "tr": 2,
      "en": 2
    },
    "headings": {
      "tr": [],
      "en": []
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "ai",
      "llm",
      "evaluation",
      "drift",
      "product-quality"
    ],
    "tags": [
      "ai",
      "llm",
      "evaluation",
      "drift",
      "product-quality"
    ]
  },
  {
    "slug": "consistency-budgets-streaming-interfaces",
    "source": "cms",
    "publishedAt": "2026-01-09",
    "title": {
      "tr": "Streaming Arayüzlerde Tutarlılık Bütçesi",
      "en": "Consistency Budgets in Streaming Interfaces"
    },
    "excerpt": {
      "tr": "Streaming ile hızlı görünen ama zihinsel olarak parçalı kalan ekranları nasıl toparladığımızı, state sınırları ve fallback hiyerarşisi üzerinden anlatıyorum.",
      "en": "How we prevent streaming UIs from becoming cognitively fragmented by designing state boundaries and fallback hierarchy intentionally."
    },
    "category": {
      "tr": "Frontend",
      "en": "Frontend"
    },
    "readingMinutes": {
      "tr": 2,
      "en": 2
    },
    "headings": {
      "tr": [],
      "en": []
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "react",
      "streaming-ui",
      "suspense",
      "frontend",
      "state-architecture"
    ],
    "tags": [
      "react",
      "streaming-ui",
      "suspense",
      "frontend",
      "state-architecture"
    ]
  },
  {
    "slug": "developer-experience-as-architecture",
    "source": "cms",
    "publishedAt": "2025-11-07",
    "title": {
      "tr": "Geliştirici Deneyimi Bir Mimari Karardır",
      "en": "Developer Experience Is an Architectural Decision"
    },
    "excerpt": {
      "tr": "DX’i yalnız araç tercihi sanmak yanıltıcıdır. Repo sınırları, test topolojisi ve ownership modeli teslimat hızını doğrudan belirler.",
      "en": "DX is not merely tooling preference; repository boundaries, test topology, and ownership design directly shape delivery throughput."
    },
    "category": {
      "tr": "Mühendislik",
      "en": "Engineering"
    },
    "readingMinutes": {
      "tr": 2,
      "en": 2
    },
    "headings": {
      "tr": [],
      "en": []
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "engineering",
      "developer-experience",
      "testing",
      "ownership",
      "architecture"
    ],
    "tags": [
      "engineering",
      "developer-experience",
      "testing",
      "ownership",
      "architecture"
    ]
  },
  {
    "slug": "release-geometry-progressive-risk-slicing",
    "source": "cms",
    "publishedAt": "2025-10-04",
    "title": {
      "tr": "Release Geometrisi: Büyük Deploy’u Küçük Risklere Bölmek",
      "en": "Release Geometry: Slicing Big Deployments into Small Risks"
    },
    "excerpt": {
      "tr": "Kod boyutu değil risk şekli belirleyicidir. Progressive delivery ile blast radius’i nasıl küçülttüğümüzü sistematik olarak anlatıyorum.",
      "en": "Deployment safety is determined less by change size and more by risk shape. This article shows a systematic progressive delivery model."
    },
    "category": {
      "tr": "Mühendislik",
      "en": "Engineering"
    },
    "readingMinutes": {
      "tr": 2,
      "en": 2
    },
    "headings": {
      "tr": [],
      "en": []
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "engineering",
      "release",
      "progressive-delivery",
      "canary",
      "rollback"
    ],
    "tags": [
      "engineering",
      "release",
      "progressive-delivery",
      "canary",
      "rollback"
    ]
  },
  {
    "slug": "offline-first-mobile-sync-conflict-discipline",
    "source": "cms",
    "publishedAt": "2025-09-19",
    "title": {
      "tr": "Offline-First Mobilde Senkron Çatışmalarını Yönetmek",
      "en": "Conflict Discipline in Offline-First Mobile Sync"
    },
    "excerpt": {
      "tr": "Offline-first mimariyi açmak kolay, kullanıcı güvenini kaybetmeden çatışma çözmek zor. Üretimde çalışan conflict disiplinini ele alıyorum.",
      "en": "Enabling offline mode is straightforward; preserving trust through conflict resolution under real sync pressure is the hard engineering work."
    },
    "category": {
      "tr": "Mobil",
      "en": "Mobile"
    },
    "readingMinutes": {
      "tr": 2,
      "en": 2
    },
    "headings": {
      "tr": [],
      "en": []
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "mobile",
      "offline-first",
      "sync",
      "conflict-resolution",
      "react-native"
    ],
    "tags": [
      "mobile",
      "offline-first",
      "sync",
      "conflict-resolution",
      "react-native"
    ]
  },
  {
    "slug": "srv-obs-2025",
    "source": "cms",
    "publishedAt": "2025-04-05",
    "title": {
      "tr": "Ölçekte Serverless Gözlemlenebilirlik",
      "en": "Serverless Observability at Scale"
    },
    "excerpt": {
      "tr": "Geçici runtime ortamlarında trace, log ve iş metriklerini birlikte anlamlı tutmanın pratik yaklaşımı.",
      "en": "How to keep traces, logs, and business signals coherent in highly ephemeral runtimes."
    },
    "category": {
      "tr": "Mühendislik",
      "en": "Engineering"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "Incident Merkezli Bakış",
        "Dashboard'dan Önce Sinyal Tasarımı",
        "Operasyonel Müdahale Modeli",
        "Ölçek Büyüdüğünde Değişen Şey"
      ],
      "en": [
        "Incident-Driven Lens",
        "Signal Design Before Dashboard Design",
        "Operational Playbook",
        "What Changes at Scale"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "serverless",
      "observability",
      "sre",
      "cloud"
    ],
    "tags": [
      "serverless",
      "observability",
      "sre",
      "cloud"
    ]
  },
  {
    "slug": "tech-debt-2025",
    "source": "cms",
    "publishedAt": "2025-03-30",
    "title": {
      "tr": "Mimari Borcu Yönetmek",
      "en": "Managing Architectural Debt"
    },
    "excerpt": {
      "tr": "Bilinçli borç alma, ödeme pencereleri ve risk odaklı teslimat için pragmatik bir yönetim modeli.",
      "en": "A pragmatic model for intentional debt, repayment windows, and risk-aware delivery."
    },
    "category": {
      "tr": "Mühendislik",
      "en": "Engineering"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "Borcu Suçlulukla Değil Portföyle Yönetmek",
        "Kullandığımız Üç Kova",
        "Roadmap'te Borç Ekonomisi",
        "Gerçekten İşleyen Ekip Ritüeli"
      ],
      "en": [
        "Debt as Portfolio, Not Guilt",
        "Three Buckets We Use",
        "Debt Economics in Roadmaps",
        "Team Rituals That Actually Work"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "architecture",
      "tech-debt",
      "delivery",
      "leadership"
    ],
    "tags": [
      "architecture",
      "tech-debt",
      "delivery",
      "leadership"
    ]
  },
  {
    "slug": "mob-perf-2025",
    "source": "cms",
    "publishedAt": "2025-03-24",
    "title": {
      "tr": "Mobil Performans İnce Ayarı",
      "en": "Mobile Performance Tuning"
    },
    "excerpt": {
      "tr": "Frame stabilitesi, açılış süresi ve ağ verimliliği için mobil performans playbook'u.",
      "en": "A practical playbook for frame stability, startup time, and network-efficient mobile UX."
    },
    "category": {
      "tr": "Mobil",
      "en": "Mobile"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "Performans = Kullanıcı Güveni",
        "Standartlaştırdığımız Profilleme Akışı",
        "Render ve Veri Disiplini",
        "İnce Ayardan Kurumsal Pratiğe"
      ],
      "en": [
        "Performance as User Trust",
        "Profiling Workflow We Standardized",
        "Rendering and Data Discipline",
        "From Tuning to Practice"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "mobile",
      "performance",
      "react-native",
      "ux"
    ],
    "tags": [
      "mobile",
      "performance",
      "react-native",
      "ux"
    ]
  },
  {
    "slug": "ai-arch-2025",
    "source": "cms",
    "publishedAt": "2025-03-18",
    "title": {
      "tr": "AI-Native Sistem Tasarımı",
      "en": "AI-Native System Design"
    },
    "excerpt": {
      "tr": "Model davranışı, güvenilirlik ve yönetişimin tasarımın parçası olduğu AI-native mimari yaklaşımı.",
      "en": "How to architect products where model behavior, reliability, and governance co-exist by design."
    },
    "category": {
      "tr": "Yapay Zeka",
      "en": "AI"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "Deterministik Olmayan Dünyaya Tasarım",
        "Politika Katmanı ve Orkestrasyon Katmanı",
        "Değerlendirmeyi Yayın Kapısına Dönüştürmek",
        "Lansman Değil Yaşam Döngüsü"
      ],
      "en": [
        "Designing for Non-Determinism",
        "Policy Layer vs Orchestration Layer",
        "Evaluation as Delivery Gate",
        "Lifecycle Over Launch Hype"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "ai",
      "system-design",
      "llm",
      "governance"
    ],
    "tags": [
      "ai",
      "system-design",
      "llm",
      "governance"
    ]
  },
  {
    "slug": "edge-comp-2025",
    "source": "cms",
    "publishedAt": "2025-03-12",
    "title": {
      "tr": "Edge Computing ve Global Gecikme",
      "en": "Edge Computing and Global Latency"
    },
    "excerpt": {
      "tr": "Tutarlılık ve operasyonel yönetilebilirliği bozmadan edge'e logic taşıma karar rehberi.",
      "en": "A decision guide for pushing logic to the edge without sacrificing consistency and operability."
    },
    "category": {
      "tr": "Mühendislik",
      "en": "Engineering"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "Edge Heyecanı Değil Gecikme Bütçesi",
        "State Topolojisi Kararı",
        "Bölgesel Hata Farkındalığı",
        "Yayın Mekaniği"
      ],
      "en": [
        "Latency Budget, Not Edge Fever",
        "State Topology Decisions",
        "Regional Failure Awareness",
        "Deployment Mechanics"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "edge",
      "latency",
      "distributed-systems",
      "architecture"
    ],
    "tags": [
      "edge",
      "latency",
      "distributed-systems",
      "architecture"
    ]
  },
  {
    "slug": "saas-mt-2025",
    "source": "cms",
    "publishedAt": "2025-03-05",
    "title": {
      "tr": "SaaS Çoklu Kiracı Mimarisi",
      "en": "SaaS Multi-Tenancy Architecture"
    },
    "excerpt": {
      "tr": "SaaS platformlarında tenant izolasyonu, maliyet verimliliği ve operasyonel sadelik dengesi.",
      "en": "How to balance tenant isolation, cost efficiency, and operational simplicity in SaaS platforms."
    },
    "category": {
      "tr": "Backend",
      "en": "Backend"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "Tenant Sınırı = Ürün Taahhüdü",
        "Modeli Kısıta Göre Seçmek",
        "Acil Durumdan Önce Geçiş Yolu",
        "Operasyonel Kontrol Katmanı"
      ],
      "en": [
        "Tenant Boundaries as Product Commitments",
        "Model Selection by Constraint",
        "Migration Strategy Before Urgency",
        "Operational Controls"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "saas",
      "multi-tenancy",
      "backend",
      "security"
    ],
    "tags": [
      "saas",
      "multi-tenancy",
      "backend",
      "security"
    ]
  },
  {
    "slug": "dist-sys-2025",
    "source": "cms",
    "publishedAt": "2025-02-28",
    "title": {
      "tr": "Dağıtık Sistem Desenleri",
      "en": "Distributed Systems Patterns"
    },
    "excerpt": {
      "tr": "Dağıtık platformlarda tutarlılık, dayanıklılık ve güvenli evrim için sahada test edilmiş desen seti.",
      "en": "A field-tested pattern set for consistency, resilience, and safe evolution in distributed platforms."
    },
    "category": {
      "tr": "Mühendislik",
      "en": "Engineering"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "Desenler Reçete Değil Bağlamdır",
        "Idempotency ve Sıralama",
        "Şema Evrimi Disiplini",
        "Hatanın Tasarım Ekseni Olması"
      ],
      "en": [
        "Patterns Are Context, Not Recipes",
        "Idempotency and Ordering",
        "Schema Evolution Discipline",
        "Failure as a First-Class Design Axis"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "distributed-systems",
      "reliability",
      "architecture",
      "backend"
    ],
    "tags": [
      "distributed-systems",
      "reliability",
      "architecture",
      "backend"
    ]
  },
  {
    "slug": "react-conc-2025",
    "source": "cms",
    "publishedAt": "2025-02-20",
    "title": {
      "tr": "Concurrent React ve Transition'lar",
      "en": "Concurrent React and Transitions"
    },
    "excerpt": {
      "tr": "Önceliklendirilmiş render ve kesintiye dayanıklı akışlarla daha akıcı React arayüzleri tasarlamak.",
      "en": "Designing responsive interfaces with prioritized rendering and interruption-safe UI flows."
    },
    "category": {
      "tr": "Frontend",
      "en": "Frontend"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "Sadece Hook Değil Öncelik Modeli",
        "Kesintiye Dayanıklı State Mimarisi",
        "Suspense Sınırını UX Sözleşmesi Gibi Tasarlamak",
        "Production'da Öğrendiklerimiz"
      ],
      "en": [
        "UI Priorities, Not Just Hook Tricks",
        "State Architecture for Interruptibility",
        "Suspense Boundaries as UX Contracts",
        "Production Lessons"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "react",
      "frontend",
      "performance",
      "ux"
    ],
    "tags": [
      "react",
      "frontend",
      "performance",
      "ux"
    ]
  },
  {
    "slug": "node-ev-2025",
    "source": "cms",
    "publishedAt": "2025-02-12",
    "title": {
      "tr": "Node.js Event Loop İç Yapısı",
      "en": "Node.js Event Loop Internals"
    },
    "excerpt": {
      "tr": "Gecikme sıçramaları ve throughput tavanlarını doğru teşhis etmek için event loop fazlarını anlamak.",
      "en": "Understanding event loop phases to diagnose latency spikes and throughput ceilings confidently."
    },
    "category": {
      "tr": "Mühendislik",
      "en": "Engineering"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "CPU Efsanesinden Scheduling Gerçeğine",
        "Faz Farkındalıklı Profilleme",
        "Backpressure ve Kuyruk Sözleşmesi",
        "Operasyon Modeli"
      ],
      "en": [
        "From CPU Myth to Scheduling Reality",
        "Phase-Aware Profiling",
        "Backpressure and Queue Contracts",
        "Operating Model"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "nodejs",
      "event-loop",
      "backend",
      "performance"
    ],
    "tags": [
      "nodejs",
      "event-loop",
      "backend",
      "performance"
    ]
  },
  {
    "slug": "rn-jsi-2025",
    "source": "cms",
    "publishedAt": "2025-02-05",
    "title": {
      "tr": "React Native JSI Mimarisi",
      "en": "React Native JSI Architecture"
    },
    "excerpt": {
      "tr": "JSI'ın bridge sınırlarını nasıl yeniden tanımladığı ve yüksek performanslı native entegrasyonları nasıl mümkün kıldığı.",
      "en": "How JSI reshapes bridge boundaries and unlocks high-performance native integrations."
    },
    "category": {
      "tr": "Mobil",
      "en": "Mobile"
    },
    "readingMinutes": {
      "tr": 3,
      "en": 3
    },
    "headings": {
      "tr": [
        "JSI'ın Gerçek Değer Ürettiği Nokta",
        "Native Sınır Sözleşmeleri",
        "Kademeli Yayın Stratejisi",
        "Uzun Vadeli Bakım"
      ],
      "en": [
        "Where JSI Truly Pays Off",
        "Native Boundary Contracts",
        "Rollout Strategy",
        "Long-Term Maintainability"
      ]
    },
    "locales": [
      "tr",
      "en"
    ],
    "rawTags": [
      "react-native",
      "jsi",
      "mobile",
      "architecture"
    ],
    "tags": [
      "react-native",
      "jsi",
      "mobile",
      "architecture"
    ]
  }
];
